"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const continue_shopping_button_1 = require("ts/classes/continue-shopping-button");
new continue_shopping_button_1.ContinueShoppingButton().init();
const picker = document.getElementById('deliverydate');
picker === null || picker === void 0 ? void 0 : picker.addEventListener('input', function (e) {
    const date = new Date(this.value);
    const day = date.getUTCDay();
    if (date.getFullYear() < 2000) {
        return;
    }
    if ([6, 0].includes(day)) {
        e.preventDefault();
        this.value = '';
        alert('Leverdatum in weekend is niet mogelijk');
    }
});
